<template>
  <el-dialog
    :title="$t('basicData.CustomVersion')"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :show-close="false"
  >
    <div class="dialog-content">
      <!-- 版本选择 -->
      <div class="version-select">
        <span class="label">{{ $t('basicData.VersionSelection') }}</span>
        <el-radio-group v-model="versionType" class="radio-group">
          <el-radio :label="1">{{ $t('basicData.LatestVersion') }}</el-radio>
          <el-radio :disabled="!isDisable" :label="2">{{ $t('basicData.CustomVersion') }}</el-radio>
        </el-radio-group>
      </div>

      <!-- 说明文字 -->
      <div class="tip-box">
        <i class="el-icon-warning tip-icon" />
        <div class="tip-content">
          <p><strong>{{ $t('basicData.LatestVersion') }}：</strong>{{ $t('basicData.RecalculateUsingLatestEffectivePricing') }}</p>
          <p><strong>{{ $t('basicData.CustomVersion') }}：</strong>{{ $t('basicData.RecalculateWithSelectedPricing') }}</p>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleCancel">{{ $t('basicData.Cancel') }}</el-button>
      <el-button type="primary" size="small" @click="handleConfirm">{{ $t('basicData.determine') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TipDialog',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    isDisable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      versionType: 1
    };
  },
  watch: {
    visible: {
      handler(val) {
        console.log('自定义版本', val, this.dialogVisible);
        this.dialogVisible = val;
        this.versionType = 1;
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      // 重置
      this.dialogVisible = false;
      this.versionType = 1;
    },
    handleCancel() {
      this.handleClose();
      this.$emit('close');
    },
    handleConfirm() {
      this.dialogVisible = false;
      this.$emit('confirm', { versionType: this.versionType });
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-content {
  .version-select {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .label {
      min-width: 80px;
      font-size: 14px;
      color: #606266;
    }

    .radio-group {
      flex: 1;
    }
  }

  .tip-box {
    display: flex;
    align-items: flex-start;
    padding: 12px;
    border: 1px solid #00A551;
    border-radius: 4px;
    background-color: #F2FBF6;

    .tip-icon {
      font-size: 18px;
      color: #e6a23c;
      margin-right: 10px;
      margin-top: 7px;
    }

    .tip-content {
      flex: 1;
      font-size: 13px;
      color: #606266;
      line-height: 1.8;

      p {
        margin: 5px 0;

        strong {
          color: #303133;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
